import { TextField } from "@mui/material";
import { useSelector } from "react-redux";
import { useAppDispatch } from "../../redux/store";
import { setEventItem } from "../../redux/Reducers/createPostReducer";
import { styles } from "./CreatePostStyles";
import Section from "./Section";
import { T } from "react-translator-component";

export default function EventUrl() {
  const dispatch = useAppDispatch();
  const url = useSelector((state: any) => state.createPost.values.event.url);

  return (
    <Section
      title={T("url")}
      body={
        <TextField
          style={styles.textField}
          onChange={(event) => dispatch(setEventItem({key: 'url', value: event.target.value}))}
          value={url}
          placeholder={`${T("url_placeholder")}`}
          multiline
          rows={5}
          variant="outlined"
          fullWidth
        />
      }
    />
  )
}
